import { render, staticRenderFns } from "./TepSolicitudAsignacion.vue?vue&type=template&id=6516131e"
import script from "./TepSolicitudAsignacion.vue?vue&type=script&lang=js"
export * from "./TepSolicitudAsignacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports